// Cyber Security Insurance Policy Constants and Data
import cancelPolicy from "../../assets/images/cancelPolicy.svg";
import refreshIcon from "../../assets/images/refresh-dark.svg";

// Cyber Security-specific action type constants
export const CANCEL_POLICY_CYBER_SECURITY = "CANCEL_POLICY_CYBER_SECURITY";

// Cyber Security Policy Overview Data
export const cyberSecurityPolicyOverview = {
  policyInfo: {
    policy_label: "Your Cyber Security Policy",
    policy_label_ar: "وثيقة تأمين الأمن السيبراني",
    status: "Active",
    status_ar: "نشيط",
    planName: "Cyber Security Insurance Policy",
    planName_ar: "وثيقة تأمين الأمن السيبراني",
    policyNumber: "",
    date: {
      startDate: "",
      endDate: "",
    },
    btn: {
      icon: refreshIcon,
      btn_lable_en: "Renew Policy",
      btn_lable_ar: "تجديد الوثيقة",
    },
  },
  cards: [
    {
      icon: "",
      value: "24/7 Support",
      value_ar: "دعم على مدار الساعة",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Cyber Coverage",
      value_ar: "تغطية الأمن السيبراني",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Claim Support",
      value_ar: "دعم المطالبات",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    }
  ]
};

// Cyber Security Policy Manage Actions (only Cancel Policy)
export const manageCyberSecurityPolicy = {
  cards: [
    {
      icon: cancelPolicy,
      value: "Cancel Policy",
      value_ar: "إلغاء السياسة",
      type: CANCEL_POLICY_CYBER_SECURITY
    }
  ]
};

// Cyber Security Benefits
export const cyberSecurityBenefits = [
  "Identity Theft Protection",
  "Data Breach Response",
  "Cyber Fraud Coverage",
  "Privacy Violation Protection",
  "24/7 Cyber Support"
];

// Function to filter cards for cyber security (only cancel policy)
export const getFilteredCyberSecurityCards = (policyDetails) => {
  return manageCyberSecurityPolicy.cards;
};